// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sdgs[data-v-98e51f44]{display:flex;flex-wrap:wrap;margin:-5px}.sdgs .sdg[data-v-98e51f44]{margin:5px;position:relative}.sdgs .sdg .active[data-v-98e51f44]{position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;transition:opacity .3s}.sdgs .sdg.is-active .active[data-v-98e51f44]{opacity:1}", ""]);
// Exports
module.exports = exports;
